import { __decorate } from "tslib";
import Component from 'vue-class-component';
import appStoresQuery from '@/plugins/graphql/queries/v2/store_management/mall-stores.gql';
import { MallStoreModel } from '@/helpers/entities/models/MallStoreModel';
import { Mixins } from 'vue-property-decorator';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
let StoreManager = class StoreManager extends Mixins(RouterParamsAppMixin) {
};
StoreManager = __decorate([
    Component({
        apollo: {
            stores: {
                query: appStoresQuery,
                variables() {
                    return {
                        appUuid: this.appUUID,
                    };
                },
                update(data) {
                    const stores = data.appStores.edges;
                    const storeNode = (store) => {
                        return new MallStoreModel(store.node);
                    };
                    return stores.map(storeNode);
                },
            },
        },
    })
], StoreManager);
export default StoreManager;
